import { render } from "./ReportSelectCard.vue?vue&type=template&id=62666d5a&scoped=true"
import script from "./ReportSelectCard.vue?vue&type=script&lang=js"
export * from "./ReportSelectCard.vue?vue&type=script&lang=js"

import "./ReportSelectCard.vue?vue&type=style&index=0&id=62666d5a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62666d5a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBadge,QIcon});
